/* ============================================================================
   ChickStix PDP controller — vanilla, namespaced, no framework.
   Drives every price from the live product variants (carried as data-* on each
   supply tile) so the page auto-updates when the merchant restructures the
   product. Handles: supply/mode selection, live price recompute, AJAX add to
   cart, gallery, FAQ, sticky bar, and scroll-triggered count-ups.
   ============================================================================ */
(function () {
  'use strict';
  if (window.__chickstixPDPInit) return;
  window.__chickstixPDPInit = true;

  var doc = document;
  function $(s, c) { return (c || doc).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || doc).querySelectorAll(s)); }

  function boot() {
    var tiles = $$('[data-cs-tile]');
    if (!tiles.length) return; // not the ChickStix template

    var cfgEl = $('#cs-pdp-data');
    var cfg = {};
    try { cfg = JSON.parse(cfgEl ? cfgEl.textContent : '{}') || {}; } catch (e) { cfg = {}; }
    var SYMBOL = cfg.symbol || '$';
    var UNIT = cfg.perUnitSuffix || 'mo';
    var hasPlan = !!cfg.hasPlan;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function money(cents) { return SYMBOL + (cents / 100).toFixed(2); }
    function easeOutCubic(x) { return 1 - Math.pow(1 - x, 3); }

    /* ---- base unit (once-price of the smallest-count variant) ------------- */
    var minCount = Infinity, baseTile = null;
    tiles.forEach(function (t) {
      var c = parseInt(t.dataset.count, 10) || 1;
      if (c < minCount) { minCount = c; baseTile = t; }
    });
    var baseUnitCents = baseTile
      ? Math.round((parseInt(baseTile.dataset.once, 10) || 0) / (parseInt(baseTile.dataset.count, 10) || 1))
      : 0;

    /* ---- state ------------------------------------------------------------ */
    var state = {
      mode: hasPlan ? (cfg.defaultMode === 'once' ? 'once' : 'sub') : 'once',
      selected: tiles.filter(function (t) { return t.dataset.default === 'true'; })[0]
                || tiles[Math.min(1, tiles.length - 1)] || tiles[0]
    };

    function totalFor(t, mode) {
      var once = parseInt(t.dataset.once, 10) || 0;
      var sub = t.dataset.sub ? parseInt(t.dataset.sub, 10) : null;
      return (mode === 'sub' && sub != null) ? sub : once;
    }

    /* ---- render ----------------------------------------------------------- */
    function render() {
      if (!hasPlan) state.mode = 'once';

      tiles.forEach(function (t) {
        var c = parseInt(t.dataset.count, 10) || 1;
        var total = totalFor(t, state.mode);
        var perCents = Math.round(total / c);
        var saveCents = baseUnitCents * c - total;

        var priceEl = $('[data-cs-tile-price]', t);
        if (priceEl) priceEl.innerHTML = money(perCents) + '<span class="cs-tile__per">/' + UNIT + '</span>';
        var saveEl = $('[data-cs-tile-save]', t);
        if (saveEl) saveEl.textContent = saveCents > 50 ? 'Save ' + money(saveCents) : '';

        t.classList.toggle('is-selected', t === state.selected);
        t.classList.toggle('is-multi', c > 1);
      });

      var sel = state.selected;
      var once = parseInt(sel.dataset.once, 10) || 0;
      var sub = sel.dataset.sub ? parseInt(sel.dataset.sub, 10) : null;
      var total = totalFor(sel, state.mode);
      var title = sel.dataset.title || 'ChickStix';

      // mode cards
      setAll('[data-cs-once-price]', money(once));
      if (hasPlan && sub != null) {
        setAll('[data-cs-sub-price]', money(sub));
        setAll('[data-cs-sub-strike]', money(once));
        var pct = Math.max(0, Math.round((1 - sub / once) * 100));
        setAll('[data-cs-sub-pct]', 'SAVE ' + pct + '%');
      }
      $$('[data-cs-mode]').forEach(function (m) {
        m.classList.toggle('is-selected', m.getAttribute('data-cs-mode') === state.mode);
      });

      // every price token on the page (CTA label, bands, sticky)
      setAll('[data-cs-price]', money(total));

      // billing summary
      var summary = state.mode === 'sub'
        ? title + ' · subscription — billed ' + money(total) + ' per delivery · cancel anytime'
        : title + ' · one-time purchase';
      setAll('[data-cs-summary]', summary);

      // sticky title
      setAll('[data-cs-sticky-title]', 'ChickStix · ' + title + (state.mode === 'sub' ? ' · subscription' : ''));
    }

    function setAll(sel, text) { $$(sel).forEach(function (el) { el.textContent = text; }); }

    /* ---- graceful degrade when no selling plan ---------------------------- */
    if (!hasPlan) {
      $$('[data-cs-mode="sub"]').forEach(function (el) { el.style.display = 'none'; });
      $$('[data-cs-modes]').forEach(function (el) { el.classList.add('cs-modes--no-sub'); });
    }

    /* ---- interactions ----------------------------------------------------- */
    tiles.forEach(function (t) {
      t.addEventListener('click', function () { state.selected = t; render(); });
    });

    $$('[data-cs-mode]').forEach(function (m) {
      m.addEventListener('click', function () {
        var v = m.getAttribute('data-cs-mode');
        if (v === 'sub' && !hasPlan) return;
        state.mode = v; render();
      });
    });

    var buybox = $('[data-cs-buybox]');
    function scrollToBuybox() {
      var target = buybox || tiles[0];
      if (!target) return;
      var y = target.getBoundingClientRect().top + window.pageYOffset - 70;
      window.scrollTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' });
    }
    $$('[data-cs-scroll]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); scrollToBuybox(); });
    });
    $$('[data-cs-choose-max]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var max = tiles[0], mc = -1;
        tiles.forEach(function (t) { var c = parseInt(t.dataset.count, 10) || 1; if (c > mc) { mc = c; max = t; } });
        state.selected = max;
        state.mode = hasPlan ? 'sub' : 'once';
        render();
        scrollToBuybox();
      });
    });

    /* ---- add to cart → /cart (cart_type=page, no drawer) ------------------ */
    function addToCart(btn) {
      var sel = state.selected;
      var id = parseInt(sel.dataset.variantId, 10);
      if (!id) return;
      var item = { id: id, quantity: 1 };
      if (state.mode === 'sub' && hasPlan && sel.dataset.plan) item.selling_plan = parseInt(sel.dataset.plan, 10);
      var original = btn ? btn.getAttribute('data-label-busy') || 'Adding…' : null;
      var prev = btn ? btn.innerHTML : null;
      if (btn) { btn.disabled = true; btn.style.opacity = '0.7'; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [item] })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      }).then(function () {
        window.location.href = '/cart';
      }).catch(function (err) {
        console.error('[ChickStix] add to cart failed', err);
        if (btn) { btn.disabled = false; btn.style.opacity = ''; btn.innerHTML = prev; }
        var msg = (err && (err.description || err.message)) || 'Sorry — could not add to cart. Please try again.';
        var note = $('[data-cs-cart-error]');
        if (note) { note.textContent = msg; note.style.display = 'block'; }
        else { window.alert(msg); }
      });
    }
    $$('[data-cs-add]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); addToCart(b); }); });

    /* ---- gallery (thumbs + swipe) ----------------------------------------- */
    var hero = $('[data-cs-hero]');
    var thumbs = $$('[data-cs-thumb]');
    var galleryIndex = 0;

    function showImage(i) {
      if (!thumbs.length) return;
      galleryIndex = (i % thumbs.length + thumbs.length) % thumbs.length; // wrap
      var th = thumbs[galleryIndex];
      var full = th.getAttribute('data-full');
      if (hero && full) hero.src = full;
      thumbs.forEach(function (o) { o.classList.remove('is-active'); });
      th.classList.add('is-active');
    }

    thumbs.forEach(function (th, i) {
      th.addEventListener('click', function () { showImage(i); });
    });

    // swipe the hero (touch or click-drag) to move between images
    var heroBox = hero ? (hero.closest('.cs-gallery__hero') || hero) : null;
    if (heroBox && thumbs.length > 1) {
      var startX = 0, startY = 0, tracking = false;
      heroBox.addEventListener('pointerdown', function (e) {
        startX = e.clientX; startY = e.clientY; tracking = true;
        try { heroBox.setPointerCapture(e.pointerId); } catch (err) {}
      });
      heroBox.addEventListener('pointerup', function (e) {
        if (!tracking) return;
        tracking = false;
        var dx = e.clientX - startX, dy = e.clientY - startY;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          showImage(galleryIndex + (dx < 0 ? 1 : -1)); // left = next, right = prev
        }
      });
      heroBox.addEventListener('pointercancel', function () { tracking = false; });
    }

    /* ---- FAQ (single-open) ------------------------------------------------ */
    $$('[data-cs-faq-q]').forEach(function (q) {
      q.addEventListener('click', function () {
        var item = q.closest('.cs-faq__item');
        var open = item.classList.contains('is-open');
        $$('.cs-faq__item').forEach(function (it) { it.classList.remove('is-open'); it.querySelector('[data-cs-faq-q]').setAttribute('aria-expanded', 'false'); });
        if (!open) { item.classList.add('is-open'); q.setAttribute('aria-expanded', 'true'); }
      });
    });

    /* ---- scroll-triggered: stat count-up, ingredient fill, sticky --------- */
    var statsDone = false, ingDone = false;
    var statbar = $('[data-cs-statbar]');
    var statEls = $$('[data-cs-stat]');
    var ingWrap = $('[data-cs-ingredients]');
    var ingRows = $$('[data-cs-ing]');
    var sticky = $('[data-cs-sticky]');

    function setStats(p) {
      statEls.forEach(function (el) {
        var target = parseFloat(el.getAttribute('data-target')) || 0;
        var dec = parseInt(el.getAttribute('data-decimals'), 10) || 0;
        el.textContent = (target * p).toFixed(dec);
      });
    }
    function setIng(p) {
      // bars fill via CSS (.is-revealed); JS only counts the dose numbers up
      ingRows.forEach(function (row, i) {
        var pi = Math.max(0, Math.min(1, (p - i * 0.08) / 0.5));
        var e = easeOutCubic(pi);
        var num = parseFloat(row.getAttribute('data-dose-num')) || 0;
        var unit = row.getAttribute('data-dose-unit') || '';
        var dose = row.querySelector('[data-cs-ing-dose]');
        if (dose) dose.textContent = Math.round(num * e) + unit;
      });
    }

    function runStats() {
      if (statsDone || !statbar) return;
      var vh = window.innerHeight || 800;
      if (statbar.getBoundingClientRect().top < vh - 60) {
        statsDone = true;
        if (reduce) { setStats(1); return; }
        var t0 = performance.now();
        (function step(t) {
          var p = Math.min(1, (t - t0) / 1300);
          setStats(easeOutCubic(p));
          if (p < 1) requestAnimationFrame(step);
        })(t0);
      }
    }
    function runIng() {
      if (ingDone || !ingWrap) return;
      var vh = window.innerHeight || 800;
      if (ingWrap.getBoundingClientRect().top < vh - 120) {
        ingDone = true;
        ingWrap.classList.add('is-revealed'); // CSS fills the bars
        if (reduce) { setIng(1); return; }
        var t0 = performance.now();
        (function step(t) {
          var p = Math.min(1, (t - t0) / 2000);
          setIng(p);
          if (p < 1) requestAnimationFrame(step);
        })(t0);
      }
    }
    function runSticky() {
      if (!sticky || !buybox) return;
      var off = buybox.getBoundingClientRect().bottom < 80;
      sticky.classList.toggle('is-visible', off);
    }

    if (statEls.length) setStats(0);
    if (ingRows.length) setIng(0);

    var onScroll = function () { runStats(); runIng(); runSticky(); };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    // fire even if a section is already in view / user scrolls past quickly
    setTimeout(onScroll, 300);
    onScroll();

    // Reliable trigger: run the count-ups/bar fills the moment a section
    // actually scrolls into view (scroll-position math alone can miss).
    if ('IntersectionObserver' in window) {
      var inView = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) onScroll(); });
      }, { rootMargin: '0px 0px -8% 0px' });
      if (ingWrap) inView.observe(ingWrap);
      if (statbar) inView.observe(statbar);
    }

    render();
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
